export default __webpack_public_path__ + "static/web/media/Flow-Logo.5e6caf2e.png";